import { ExpirationDays } from '../Config/Cookies';
import { trackCustomEvent } from '../Config/DataDog';
import { createCookie } from './Cookies';

const setupCookies = (userInfo) => {
    const cookiesData = buildCookiesData(userInfo);
    cookiesData.forEach((cookie) => {
        createCookie(cookie.name, cookie.value, ExpirationDays);
    });
    trackCustomEvent("SetupCookies", false, formatCookiesDataToObject(cookiesData));
};

const buildCookiesData = (userInfo) => {
    const data = [];
    for (let key in userInfo) {
        if (!!userInfo[key]) {
            switch (key) {
                case 'credencial_club':
                    data.push({
                        name: 'usuarioDetalleClubNacion',
                        value: userInfo[key]?.tipo,
                    });
                    break;
                case 'email':
                    data.push({ name: 'usuarioemail', value: userInfo[key] });
                    break;
                case 'productos_premium':
                    if (userInfo[key].length > 0) {
                        data.push({
                            name: 'ProductoPremiumId',
                            value: userInfo[key],
                        });
                    }
                    break;
                case 'crmid':
                    data.push({ name: 'Crm_id', value: userInfo[key] });
                    break;
                case 'ln_nickname':
                    data.push({
                        name: 'usuario%5Fdetalle%5Fnick',
                        value: userInfo[key],
                    });
                    data.push({
                        name: 'usuario%5Fusuario',
                        value: userInfo[key],
                    });
                    break;
                case 'ln_user_id':
                    data.push({ name: 'usuario%5Fid', value: userInfo[key] });
                    break;
                case 'given_name':
                    data.push({
                        name: 'UsuarioDetalleNombre',
                        value: userInfo[key],
                    });
                    break;
                case 'family_name':
                    data.push({
                        name: 'UsuarioDetalleApellido',
                        value: userInfo[key],
                    });
                    break;
            }
        }
    }
    return data;
};

const formatCookiesDataToObject = (cookiesData) => {
    const cookiesLog = cookiesData.reduce((acc, obj) => {
        const [name, value] = Object.entries(obj);
        acc[name[1]] = value[1];
        return acc;
    }, {})
    return cookiesLog
}
export default setupCookies;
